import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MsgBoxData {
  title: string;
  content: string;
  buttons: string[];
  list: string[];
}

@Component({
  selector: 'i-msgbox',
  templateUrl: './msgbox.component.html',
  styleUrls: ['./msgbox.component.scss'],
})
export class MsgBoxComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: MsgBoxData) {}
}
